"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const InfoLinkWithModal_1 = tslib_1.__importDefault(require("../ui/InfoLinkWithModal"));
const VMRebootConfigurationInfo_1 = require("../../../common/components/hosts/VMRebootConfigurationInfo");
const use_translation_wrapper_1 = require("../../../common/hooks/use-translation-wrapper");
const VMRebootConfigurationLinkWithModal = () => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    const title = t('ai:Check your VM reboot configuration');
    return (react_1.default.createElement(InfoLinkWithModal_1.default, { linkText: title, modalTitle: title, modalVariant: 'medium', isInline: true, linkId: "check-reboot-configuration", modalId: "check-reboot-configuration" },
        react_1.default.createElement(VMRebootConfigurationInfo_1.VMRebootConfigurationContent, null)));
};
exports.default = VMRebootConfigurationLinkWithModal;
//# sourceMappingURL=VMRebootConfigurationLinkWithModal.js.map